<template>
  <div class="switch" :disabled="disabled" @click="click">
    <div class="switch-background" :class="backgroundClass">
      <div class="switch-spot" :style="positionStyle"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      checked: this.value
    }
  },
  computed: {
    backgroundClass () {
      let s = `switch-background-${this.checked}`
      if (this.disabled) {
        s += '-disabled'
      }
      return s
    },
    positionStyle () {
      if (this.checked) {
        return 'left: 43px'
      }
    }
  },
  methods: {
    click () {
      if (this.disabled) {
        return
      }
      this.checked = !this.checked
      this.$emit('click', this.checked)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.switch {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
  border: none;

  @media (--mediaPc) {
    height: var(--switchHeight);
    width: var(--switchWidth);
  }
  @media (--mediaMobile) {
    height: var(--switchHeightMobile);
    width: var(--switchWidthMobile);
  }
  & .switch-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    transition-property: all;
    transition-duration: .35s;
    transition-timing-function: ease-out;

    @media (--mediaPc) {
      border-radius: var(--switchBorderRadius);
    }
    @media (--mediaMobile) {
      border-radius: var(--switchBorderRadiusMobile);
    }
    & .switch-spot {
      position: absolute;

      top: 3px;
      left: 3px;

      background-color: var(--colorWhite);
      box-sizing: border-box;

      content: '';

      transition-property: all;
      transition-duration: .35s;
      transition-timing-function: cubic-bezier(.59,.01,.5,.99);
      @media (--mediaPc) {
        height: calc(var(--switchHeight) - 3px - 3px);
        width: calc(var(--switchHeight) - 3px - 3px);
        border-radius: var(--switchBorderRadius);
      }
      @media (--mediaMobile) {
        height: calc(var(--switchHeightMobile) - 3px - 3px);
        width: calc(var(--switchHeightMobile) - 3px - 3px);
        border-radius: var(--switchBorderRadiusMobile);
      }
    }
  }
  & .switch-background-true {
    box-shadow: inset 0 0 0 1px var(--colorMain);
    background-color: var(--colorMain);
    cursor: pointer;
  }
  & .switch-background-false {
    box-shadow: inset 0 0 0 1px var(--colorDisabled);
    background-color: var(--colorDisabled);
    cursor: pointer;
  }
  & .switch-background-true-disabled {
    box-shadow: inset 0 0 0 1px var(--colorDisabled);
    cursor: not-allowed;
  }
  & .switch-background-false-disabled {
    box-shadow: inset 0 0 0 1px var(--colorDisabled);
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/switch/BaseSwitch.vue